import * as React from 'react';

function Taekwondo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M17.25 18v2.25a.75.75 0 01-.578.73l-.084.015L16.5 21h-9a.75.75 0 01-.746-.662l-.004-.088V18H17.25zm0-2.25v1.5H6.75v-1.5h10.5zM7.292 3.39l3.684 6.36.03.049L7.83 15H7.5v-2.25l-.005-.087a.75.75 0 00-1.49 0L6 12.75V15H3.75a.751.751 0 01-.748-.801l.011-.084.021-.085 3-9.75a.75.75 0 01.306-.407l.075-.044.877-.439zm9.396-.01l.898.45a.75.75 0 01.35.368l.03.082 3 9.75a.75.75 0 01-.628.966L20.25 15H18v-2.25l-.005-.087a.75.75 0 00-1.49 0l-.005.087V15H9.587l7.101-11.62zM15.162 3l-3.267 5.345L8.8 3h6.362z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Taekwondo;
